var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#2D38AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9519 11.9678V14.9199H26.3259L28.0125 16.6064L26.3259 18.2939H22.9519V19.9805H27.1697L25.0603 21.667L27.1697 23.3545H22.9519V29.7861H19.156V23.3545H13.6736L11.9871 21.667L13.6736 19.9805H19.156V18.2939H15.783L17.8914 16.6064L15.783 14.9199H19.156V11.9678L21.0544 9.85938L22.9519 11.9678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL2);
export default __webpack_public_path__ + "static/media/l2.d21e1be7c20b8dc6e1b2f6d8ec49f2a4.svg";
export { ForwardRef as ReactComponent };